/**
 * Test IDs for QA automation.
 */
export const testIds = {
  loadBoardLoadDetailsImportOrder: "load-board-load-details-import-order",
} as const;
